export default __webpack_public_path__ + "static/media/trash.11066899.svg";